import React from 'react';
import { UserModel } from '../../../interfaces/user.interface';
import Heading from '../../../components/Common/Heading';
import Loader from '../../../components/Common/Loader';
import { PlanDetailsModel } from '../../../interfaces/plan.interface';

interface PlanDetailsProps {
  user: UserModel | null;
  loader: { removeSubscription: boolean };
  currentPlanDescription: PlanDetailsModel | null | undefined;
  setOpenDialog: () => void;
}

const PlanDetails: React.FC<PlanDetailsProps> = ({ user, loader, currentPlanDescription, setOpenDialog }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-4 justify-between mt-4">
        <div className="w-full flex flex-col gap-1">
          <Heading title={'Current Plan'} />
          <input
            type="text"
            name="currrentPlan"
            value={user?.plan?.name ? user?.plan?.name + (!!user?.disablePlanCancellation ? ' - Free' : '') : ''}
            readOnly
            className="mt-4 p-2 w-full rounded-md text-center"
          />
        </div>
        {(user?.plan?.freePhysicalBookStatus === true &&
          (user?.freePhysicalBookCreated || 0) <= (user?.freePhysicalBookQuantity || 0)) ||
        !!user?.disablePlanCancellation ? (
          ''
        ) : (
          <button
            type="button"
            className="flex justify-center self-end gap-2 bg-storyblue text-white font-bold rounded-2xl px-4 py-2 text-sm text-nowrap items-center"
            disabled={loader?.removeSubscription}
            onClick={setOpenDialog}
          >
            Cancel Subscription
            <Loader loader={loader?.removeSubscription} />
          </button>
        )}
      </div>
      <div>
        {currentPlanDescription && !user?.disablePlanCancellation && (
          <div className="bg-white rounded-md border-2 border-storylightgreen flex flex-col gap-1 justify-around items-start w-full my-2 p-2">
            {currentPlanDescription?.freePhysicalBookStatus === true &&
            currentPlanDescription?.freePhysicalBookQuantity ? (
              <h1 className="text-md text-storyblue">
                <strong> Free Physical Book(s): </strong>
                {currentPlanDescription?.freePhysicalBookQuantity}
              </h1>
            ) : (
              <h1 className="text-md text-storyblue">
                <strong> Monthly Stories: </strong> {currentPlanDescription?.storyCreationLimit}
              </h1>
            )}
            {user?.plan?.name !== 'PROMO_PLAN' && (
              <h1 className="text-md text-storyblue capitalize">
                <strong> Cost: </strong> $ {currentPlanDescription?.cost}
                {' / '}
                {currentPlanDescription?.chargeCycle?.replace('_', ' ')}
              </h1>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanDetails;
